import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Award } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface AgencyKpisTabProps {
  clientId: string;
  filters: FilterState;
}

export function AgencyKpisTab({ clientId, filters }: AgencyKpisTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Award className="mr-2 h-5 w-5" />
          KPIs Agence
        </CardTitle>
        <CardDescription>Performance Cosmos Wave - Impact des optimisations</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Métriques agence en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}